module.exports = __webpack_public_path__ + "img/01.6368214f.jpg";